import { useState } from 'react';

const useImageViewer = ({ streams }) => {
  const [viewerVisible, setViewerVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const imageStreams = streams.filter(val => val.content_type === 'photo');
  const imageList = imageStreams.map(val => ({ src: val.media_url, alt: '', downloadUrl: val.media_url }));
  const imageViewerData = {
    data: {
      imageList,
      viewerVisible,
      activeIndex
    },
    setViewerVisible,
    setActiveIndex
  };

  const handleImageStream = id => {
    const activeIndex = imageStreams.findIndex(stream => stream.id === id);
    setActiveIndex(activeIndex);
    setViewerVisible(true);
  };

  return {
    imageViewerData,
    handleImageStream
  };
};

export default useImageViewer;
